import { Badge } from '@chopchop-se/ui';
import type { SalesOrderStatus, StaffOrderStatus } from '@warehouse/shared';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * One place decides what colour a status is. The Swedish status names are the
 * DOMAIN language (spec §5.1: Ej hanterad → Pågående → Packat → Skickat), so
 * they are translated for readability but the underlying value never changes.
 */

const SALES_TONE: Record<SalesOrderStatus, 'neutral' | 'info' | 'brand' | 'success' | 'danger'> = {
  ej_hanterad: 'neutral',
  pagaende: 'info',
  packat: 'brand',
  skickat: 'success',
  cancelled: 'danger',
};

const STAFF_TONE: Record<StaffOrderStatus, 'neutral' | 'brand' | 'success'> = {
  registered: 'neutral',
  ready: 'brand',
  collected: 'success',
};

export function OrderStatusBadge({ status }: { status: SalesOrderStatus }): ReactNode {
  const { t } = useTranslation('salesOrders');
  return (
    <Badge tone={SALES_TONE[status]} dot minWidth>
      {t(`status.${status}`)}
    </Badge>
  );
}

export function StaffStatusBadge({ status }: { status: StaffOrderStatus }): ReactNode {
  const { t } = useTranslation('salesOrders');
  return (
    <Badge tone={STAFF_TONE[status]} dot minWidth>
      {t(`staff.status.${status}`)}
    </Badge>
  );
}
